module.exports = __webpack_public_path__ + "static/media/sanofi_logo-square.5701cef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sanofi_logo-square.jpg
// module id = 1856
// module chunks = 0